export default "__VITE_ASSET__B4D9$nMq__"